export function verificaAdmin() {
  try {
    const tokenAdmin = sessionStorage.getItem("tokenAdmin");

    if (!tokenAdmin) {
     // console.log("Sem tokenAdmin");
      return false;
    }

    const decodificado = atob(tokenAdmin);

  //  console.log("Token:", tokenAdmin);
   // console.log("Decodificado:", decodificado);

    const [id, dataLogin] = decodificado.split("|");

  //  console.log("ID:", id);
  //  console.log("Data Login:", dataLogin);

    if (id !== "34") {
      console.log("ID inválido");
      return false;
    }

    const hoje = new Date().toISOString().split("T")[0];
    const dataToken = dataLogin.split("T")[0];

  //  console.log("Hoje:", hoje);
  //  console.log("Data Token:", dataToken);

    const adminValido = dataToken === hoje;

   // console.log("Admin válido?", adminValido);

    return adminValido;
  } catch (error) {
    console.error("Erro ao verificar admin:", error);
    return false;
  }
}